// import React from "react";
// import ReactDOM from "react-dom";
// import { BrowserRouter as Router } from "react-router-dom"; // Import BrowserRouter
// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";

// ReactDOM.render(
//   <React.StrictMode>
//     <Router> {/* Single top-level Router */}
//       <App />
//     </Router>
//   </React.StrictMode>,
//   document.getElementById("root")
// );

// reportWebVitals();


import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom"; // Import the Router

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Router>  {/* Wrap your App in the Router */}
      <App />
    </Router>
  </React.StrictMode>
);

reportWebVitals();